import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { Subscription } from 'rxjs/Subscription';
import { ActivatedRoute, Router } from '@angular/router';
import { DataService } from 'src/app/services/data.service';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Location } from '@angular/common';
import { AuthService } from 'src/app/services/auth.service';



@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.sass']
})
export class SidebarComponent implements OnInit {
  managersListSubs: Subscription;
  managers: any;
  eventsListSubs: Subscription;
  events: any;
  filterForm: FormGroup;
  public email: string;
  public role: string;
  relationships: any;
  reportages: any;
  url: string[];
  @Output() sidebarToggle: EventEmitter<any> = new EventEmitter();
  activeRouteId: any = { id: 0, student_id: '' }
  showOrderBtn: Boolean;

  constructor(
    public firebase: AngularFireAuth,
    public dataService: DataService,
    public router: Router,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private location: Location,
    private authService: AuthService

  ) {
    this.email = localStorage.getItem('email');

    this.location.onUrlChange(response => {

      this.route.firstChild.data.subscribe(res => {

        if (res.id == 8) {

          this.activeRouteId.id = res.id
          this.activeRouteId.student_id = response.replace("/student/", "")

        } else {
          this.activeRouteId.id = res.id
        }


      })
    })

  }



  changeEvent(event: number) {
    this.url = this.router.url.split('/')
    this.filterForm.controls["event"].setValue(event)
    if (this.url.length > 3) {
      this.redirectTo("/event/" + event + '/' + this.url[3])
    }

  }

  ngOnInit() {

    this.filterForm = this.formBuilder.group({
      manager: new FormControl(''),
      event: new FormControl('')
      // name: new FormControl('', Validators.required),
    });

    this.dataService.getRole().subscribe(res => {
      this.role = res.toString();

    });

    this.dataService.getRelationships('', 'list').subscribe(relationships => {

      let unordered_rels = []

      for (let relationship in relationships) {
        unordered_rels.push(relationships[relationship]);
      }

      let ordered_rels = unordered_rels.sort((a, b) => {
        if (a.name < b.name) { return -1; }
        if (a.name > b.name) { return 1; }
        return 0;
      })

      this.relationships = ordered_rels;


    });

    this.dataService.getRelatedReportages('','list').subscribe(reportages => {

      let unordered_rels = []

      for (let reportage in reportages) {
        unordered_rels.push(reportages[reportage]);
      }

      let ordered_rels = unordered_rels.sort((a, b) => {
        if (a.name < b.name) { return -1; }
        if (a.name > b.name) { return 1; }
        return 0;
      })

      this.reportages = ordered_rels;


    });

    this.dataService.getTotalShoppingCart().subscribe(res => {

      if (res.status == "ok") {

        if (res.total_products > 0) {
          this.showOrderBtn = true;
        }
      }

    })



    this.route.firstChild.data.subscribe(res => {

      if (res.id == 8) {

        this.activeRouteId.id = res.id
        this.activeRouteId.student_id = this.router.url.replace("/student/", "")

      } else {
        this.activeRouteId.id = res.id
      }

    })

  }

  redirectTo(uri: string) {
    //limpiar aquí los local storage principales rutas
    localStorage.removeItem('catalogs')
    localStorage.removeItem('users')
    localStorage.removeItem('schools')
    localStorage.removeItem('templates')
    localStorage.removeItem('products')
    localStorage.removeItem('year-periods')
    localStorage.removeItem('student-photos')
    localStorage.removeItem('orders-admin')
    localStorage.removeItem('reportages')
    localStorage.removeItem('reportage-photos-details')
    localStorage.removeItem('orders-reportages')

    let url;
    this.sidebarToggle.emit();
    this.dataService.getTotalShoppingCart().subscribe(res => {

      if (res.status == "ok") {

        if (res.total_products > 0) {
          this.showOrderBtn = true;
        }
      }

    })

    if (uri == '/events') {
      url = uri + '/' + this.filterForm.controls["manager"].value;
    }
    else if ((uri == '/companies') || (uri == '/packages') || (uri == '/accrediteds')) {
      url = '/event/' + this.filterForm.controls["event"].value + '/' + uri;
    }
    else {
      url = uri
    }
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([url])


    });



  }

  logout() {

    this.authService.logout();

  }




}
